// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "@firebase/firestore";
import { getStorage } from "firebase/storage";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA-1sGcxrxXKxVosI87fcTZ2RDC0NjQCHY",
  authDomain: "jumettpeird-a3609.firebaseapp.com",
  projectId: "jumettpeird-a3609",
  storageBucket: "jumettpeird-a3609.appspot.com",
  messagingSenderId: "988949989462",
  appId: "1:988949989462:web:c948a387060728401413f7",
  measurementId: "G-3BPL7PPFGL"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
